exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._8vsZdvK9G_26e3{margin-top:30px}._8vsZdvK9G_26e3 button{margin-right:8px}@media only screen and (max-width:1020px){._1MhcKk2JrovZQ0{width:100%;min-width:375px}}", ""]);

// exports
exports.locals = {
	"buttons": "_8vsZdvK9G_26e3",
	"illustration": "_1MhcKk2JrovZQ0"
};